import React, { useRef, useState } from "react";
import ColorPicker from "react-gcolor-picker";
import { useImmer } from "use-immer";

import { IgIconButton } from "@intelligems/ig-theme";
import { Box, Grid, Popover, useTheme } from "@mui/material";

type ColorPickerProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  position?: "top" | "bottom";
  disabled: boolean;
} & Omit<React.ComponentProps<"div">, "onChange">;

export const MenuBarColorPicker = ({
  value,
  position = "bottom",
  onChange,
  disabled,
}: ColorPickerProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [anchorEl, setAnchorEl] = useImmer<HTMLElement | null>(null);

  const togglePicker = () => {
    setOpen((open) => !open);
    setAnchorEl(open ? null : ref.current);
  };

  return (
    <Grid>
      <IgIconButton
        disabled={disabled}
        ref={ref}
        onClick={togglePicker}
        sx={{ paddingLeft: 0 }}
      >
        <Box
          sx={{
            border: `1px solid ${theme.igPrimitives.gray[700]}`,
            width: 20,
            height: 20,
            borderRadius: 4,
            background: value,
          }}
        />
      </IgIconButton>

      <Popover
        id={"color-picker"}
        open={open}
        anchorEl={anchorEl}
        onClose={togglePicker}
        anchorOrigin={{
          vertical: position,
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: position === "top" ? "bottom" : "top",
          horizontal: "center",
        }}
        slotProps={{
          root: {
            sx: {
              marginTop: position === "top" ? "-5px" : "5px",
              zIndex: 2000,
            },
          },
        }}
      >
        <ColorPicker
          format={"hex"}
          solid
          value={value}
          onChange={(value) => onChange?.(value)}
        />
      </Popover>
    </Grid>
  );
};
